<template>
  <v-row>
    <v-col cols="12" class="pt-0">
      <PageTitle title="Обработка заявлений"/>
    </v-col>

    <v-col cols="12" class="py-0">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            rounded
            outlined
            color="primary"
            class="white--text px-4"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left small>mdi-plus</v-icon>
            Создать заявление
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            @click="openDialog(item)"
            :disabled="disabledListItem(item)"
            v-for="(item, index) in dictionaries.applicationTypeActual"
            :key="index"
          >
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>

    <v-col cols="12">
      <PageTable
        :table-loading="tableLoading"
        :table-headers="tableHeaders"
        :table-items="applications.list"
        :filter="checkRoles"
        :custom-sort="sortFunc"
        :show-select="checkRoles"
        :value="selectedItem"
        table-height="284"
        @get-data="getApplications"
        @input="select"
      >
        <template v-slot:button>
          <v-badge v-if="checkRoles" bordered :color="selectedItem?.length ? 'red' : 'grey'" overlap :disabled="true">
            <template v-slot:badge>
              <span>{{ selectedItem?.length || 0 }}</span>
            </template>
            <v-btn
              depressed outlined rounded small color="red"
              :disabled="!selectedItem?.length"
              @click="isRemovedItem = true"
            >
              <v-icon left small>mdi-trash-can-outline</v-icon>
              Удалить
            </v-btn>
          </v-badge>

          <v-btn
            v-if="checkRoles"
            depressed outlined rounded small color="red"
            class="ml-4"
            :disabled="!!selectedItem?.length"
            @click="isRemovedItem = true"
          >
            <v-icon left small>mdi-trash-can-outline</v-icon>
            Удалить всё
          </v-btn>


          <v-badge
            overlap
            dot
            :value="!!checkFilterProperties(applicationsFilter)"
          >
            <v-btn
              v-if="checkRoles"
              small
              rounded
              outlined
              color="primary"
              class="white--text ml-4 filter-btn"
              @click="showFilter = !showFilter"
            >
              <v-icon left small>mdi-filter-outline</v-icon>
              <span>{{ showFilter ? 'Закрыть' : 'Фильтр' }}</span>
            </v-btn>
          </v-badge>
        </template>

        <template #item.applicationStatus.name="{ item }">
          <span :class="{ 'font-weight-bold': item.applicationStatus?.id === 2 }">
            {{ item.applicationStatus?.name }}
          </span>
        </template>

        <template #item.actions="{ item }">
          <v-icon
            v-if="!checkRoles"
            color="lightGrey"
            class="mr-1"
            size="22"
            title="Отправить заявление"
            :disabled="![1, 3].includes(item.applicationStatus?.id)"
            @click="openSendDialog(item)"
          >
            mdi-send
          </v-icon>

          <v-icon color="lightGrey" class="mr-2 eye-btn" size="22" title="Просмотр" @click="show(item)">
            mdi-eye-outline
          </v-icon>

          <template v-if="!checkRoles">
            <v-icon
              v-if="item.message"
              color="lightGrey"
              class="mr-1"
              size="22"
              title="Сообщение"
            >
              {{ item.message && item.unreadNotifications ? 'mdi-email-outline' : 'mdi-email-open-outline'}}
            </v-icon>

            <v-icon
              color="lightGrey"
              :disabled="![1, 3].includes(item.applicationStatus?.id) || copyLoading"
              class="mr-1 edit-btn"
              :class="{'mdi-loading': copyLoading}"
              size="22"
              title="Редактировать"
              @click="edit(item)"
            >
              {{ copyLoading ? 'mdi-loading' : 'mdi-pencil-outline' }}
            </v-icon>

            <v-icon color="lightGrey" class="mr-1 remove-btn" size="22" title="Удалить" @click="remove(item)">
              mdi-trash-can-outline
            </v-icon>
          </template>
        </template>
      </PageTable>
    </v-col>

    <transition name="curator-filter">
      <AppFilter
        v-show="showFilter"
        @applyFilter="applyFilter"
        @closeFilter="showFilter = false"
        :application-filter="applicationsFilter"
        width-filter="1200"
        top="255"
        right="29"
      />
    </transition>

    <ApplicationCreateDialog
      :dialog="dialog"
      :item="application"
      @set-application="setApplication"
      @close-dialog="closeDialog"
    />

    <ConfirmDelete
      :dialog="removeDialog || isRemovedItem"
      :loading="buttonLoading"
      :message="messageForConfirmDelete"
      @confirm="confirm"
      @closeModal="closeDialog"
    />

    <SendDialog
      :dialog="sendDialog"
      :loading="sendLoading"
      :print-loading="printLoading"
      @get-print="getPrint"
      @confirm="send"
      @closeDialog="closeSendDialogDialog"
    />
  </v-row>
</template>

<script>
import { applicationApi, fileApi, printApi } from '@/api'
import {mapGetters, mapState, mapMutations} from 'vuex'
import { ApplicationParent, Application, ApplicationsFilter } from '@/models'
import PageTitle from '@/components/ui/Title'
import PageTable from '@/components/ui/Table'
import ApplicationCreateDialog from '@/components/zvp/application-create/Index'
import AppFilter from '@/components/zvp/applications/ApplicationsFilter'
import ConfirmDelete from '@/components/dialogs/ConfirmDelete'
import SendDialog from "@/components/dialogs/SendDialog"
import _ from 'lodash'
import download from "@/plugins/download"

export default {
  name: 'Applications',

  components: {
    PageTitle,
    ApplicationCreateDialog,
    AppFilter,
    ConfirmDelete,
    PageTable,
    SendDialog,
  },

  data: () => ({
    applications: new ApplicationParent(),
    applicationsFilter: new ApplicationsFilter(),
    application: new Application(),

    tableLoading: false,
    buttonLoading: false,
    copyLoading: false,
    sendLoading: false,
    printLoading: false,

    sendDialog: false,
    removeDialog: null,
    showFilter: false,
    dialog: false,

    pageNumber: 0,
    lastPage: false,
    selectedItem: [],
    isRemovedItem: false,
  }),

  computed: {
    ...mapGetters('user', ['isCurator', 'isAdmin']),
    ...mapState('system', ['dataLoaded']),
    ...mapState('applicationsFilter', {applicationsFilterStore: 'applicationsFilter'}),
    ...mapGetters('personalData', ['personalDataId']),
    ...mapGetters('dictionaries', ['dictionaries']),

    tableHeaders() {
      if (this.checkRoles) {
        return [
          { text: 'Номер', value: 'id', sortable: false, align: 'start' },
          { text: 'Статус', value: 'applicationStatus.name', sortable: false, align: 'start' },
          { text: 'Тип заявления', value: 'applicationType.name', sortable: false, align: 'start' },
          { text: 'Специальность', value: 'specialityTo.name', sortable: false, align: 'start' },
          { text: 'Курс', value: 'courseNumberTo.name', sortable: false, align: 'start' },
          { text: 'Тип обучения', value: 'paidFormTo.name', sortable: false, align: 'start' },
          { text: 'Дата отправки', value: 'getSendDateTimeText', sortable: false, align: 'start', width: '150px' },
          { text: 'ФИО', value: 'fullName', sortable: false, align: 'start' },
          { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '180px' }
        ]
      } else {
        return [
          { text: 'Номер', value: 'id', sortable: false, align: 'start' },
          { text: 'Статус', value: 'applicationStatus.name', sortable: false, align: 'start' },
          { text: 'Тип заявления', value: 'applicationType.name', sortable: false, align: 'start' },
          // { text: 'Дата создания', value: 'createDateTime', sortable: false, align: 'start' },
          { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '180px' },
        ]
      }
    },

    checkRoles() {
      return (this.isCurator || this.isAdmin)
    },

    messageForConfirmDelete() {
      if (this.isRemovedItem) {
        return this.selectedItem?.length
          ? `Вы уверены что хотите удалить выбранные (${ this.selectedItem?.length }) заявления?`
          : 'Вы уверены что хотите удалить все заявления?'
      } else {
        return 'Вы уверены что хотите удалить заявление?'
      }
    }
  },

  methods: {
    ...mapMutations('applicationsFilter', ['setApplicationsFilter']),

    select(item) {
      this.selectedItem = _.cloneDeep(item)
    },

    disabledListItem(item) {
      if (!this.checkRoles) {
        const rejectStatus = { id: 5, name: 'Отклонено' }

        if (item?.id === 1) return this.applications.list.some(el => {
          return el.applicationType?.id === 1 && el.applicationStatus?.id !== rejectStatus?.id
        })
      }
    },

    checkFilterProperties(applicationsFilter) {
      for(let item in applicationsFilter) {
        if (applicationsFilter[item]?.id) return true
      }
    },

    async openDialog(item) {
      try {
        await applicationApi.checkApplicationCreation()
        this.application.applicationType = item
        this.dialog = true
        this.showFilter = false
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка')
      }
    },

    sortFunc(body) {
      let appStatusTwo = body.filter(item => item.applicationStatus?.id === 2).sort((itemA, itemB) =>
        new Date(itemA.createDate) < new Date(itemB.createDate)
      )
      let otherAppStatus = body.filter(item => item.applicationStatus?.id !== 2).sort((itemA, itemB) =>
        new Date(itemA.createDate) < new Date(itemB.createDate)
      )
      return [...appStatusTwo, ...otherAppStatus]
    },

    setApplication(application) {
      this.applications.list.some(item => item.id === application.id)
        ? this.applications.update(application)
        : this.applications.add(application)
    },

    async applyFilter(item) {
      this.applicationsFilter = item ? item : new ApplicationsFilter()
      this.applications.list = []
      this.lastPage = false
      this.pageNumber = 0
      this.setApplicationsFilter(this.applicationsFilter)
      await this.getApplications()
    },

    async getApplications() {
      this.tableLoading = true
      try {
        if (!this.lastPage) {
          const {last, content} = this.checkRoles
            ? await applicationApi.findAllByFilter(this.pageNumber, this.applicationsFilter)
            : await applicationApi.findAllActualApplication(this.personalDataId)

          content?.length && content.forEach(el => this.applications.add(el))
          this.lastPage = last
          this.pageNumber++
        }
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.tableLoading = false
      }
    },

    async confirm() {
      this.buttonLoading = true
      try {
        if (this.removeDialog) {
          await applicationApi.remove(this.application.id)
          this.applications.remove(this.application)
        } else if (this.selectedItem?.length) {
          await applicationApi.deleteByApplicationIdList(this.selectedItem.map(i => i.id))
          this.selectedItem = []
        } else {
          await applicationApi.deleteAllApplication()
        }
        this.applications.list = []
        this.lastPage = false
        this.pageNumber = 0
        await this.getApplications()

        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.buttonLoading = false
      }
    },

    show(item) {
      this.$router.push(`/zvp/application-read/${item.id}`)
    },

    remove(item) {
      this.application = item
      this.removeDialog = true
    },

    async edit(item) {
      this.editApplication(item)
    },

    async copyApplication(item) {
      try {
        this.copyLoading = true
        const copy = await applicationApi.copy(item.id)
        if (copy.id) {
          const data = await applicationApi.getById(copy.id)
          this.application = Application.build(data)
        }
        this.dialog = true
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.copyLoading = false
      }
    },

    editApplication(item) {
      this.application = item
      this.dialog = true
    },

    closeDialog() {
      this.removeDialog = false
      this.dialog = false
      this.isRemovedItem = false
      this.application = new Application()
    },

    async send(files) {
      try {
        this.sendLoading = true
        const data = await this.sendFiles(files)
        data && await this.sendApplication()
        this.sendDialog = false
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.sendLoading = false
      }
    },

    async sendFiles(files) {
      try {
        for (const el of files) {
          await fileApi.postFiles(el, this.application.id, 'Application')
        }
        return true
      } catch (e) {
        this.showErrorMessage(e)
      }
    },

    async sendApplication() {
      try {
        const data = await applicationApi.sendApplication(this.application.id)
        this.application = Application.build(data)
        this.setApplication(data)
      } catch (e) {
        this.showErrorMessage(e)
      }
    },

    async getPrint() {
      try {
        this.printLoading = true
        let data
        switch (this.application.applicationType?.id) {
          case 1: data = await printApi.applicationReinstate(this.application.id)
            break
          case 2: data = await printApi.applicationTransfer(this.application.id)
            break
          case 3: data = await printApi.applicationProgramTransfer(this.application.id)
            break
        }
        data && download(data, `${this.application.applicationType.name}.pdf`)
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.printLoading = false
      }
    },

    openSendDialog(item) {
      this.application = item
      this.sendDialog = true
    },

    closeSendDialogDialog() {
      this.application = new Application()
      this.sendDialog = false
    }
  },

  watch: {
    personalDataId: {
      immediate: true,
      async handler(value) {
        if (value.id) {
          if(this.checkFilterProperties(this.applicationsFilterStore)) {
            this.applicationsFilter = _.cloneDeep(this.applicationsFilterStore)
          }
          await this.getApplications()
        }
      }
    },

    dialog: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.showFilter = false
        }
      }
    },

    sendDialog: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.showFilter = false
        }
      }
    },

    removeDialog: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.showFilter = false
        }
      }
    }
  }
}
</script>

<style scoped>

.curator-filter-enter-active {
  transition: opacity .2s;
}

.curator-filter-leave-active {
  transition: opacity .2s;
}

.curator-filter-enter, .curator-filter-leave-to {
  opacity: 0;
}

.filter-btn {
  width: 150px;
}

.filter-btn span {
  width: 70px;
}

.mdi-loading {
  animation: spinner 1s linear infinite;
}

@keyframes spinner {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
